import ip from 'icepick';
import {ReducerType} from '../types/store';
import {SET_MALL_FORM, TOGGLE_PARKING_FORM} from './type';

const initialState: ReducerType = ip.freeze({
  mallForm:{
    billList:[],
    parkingDetails:null,
    selectedMall:null,
  },
  takeParkingForm:'hide',
});

const mallParkingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MALL_FORM: {
      if (action.payload) {
        state = ip.setIn(state, ['mallForm'], action.payload);
      }
      return state;
    }
    case TOGGLE_PARKING_FORM: {
      if (action.payload) {
        state = ip.setIn(state, ['takeParkingForm'],action.payload);
      }
      return state;
    }
    default: {
      return state;
    }
  }
};

export default mallParkingReducer;
